/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAIToolReferencesPathParams = NonNullable<operations['listAIToolReferences']['parameters']['path']>;

export type ListAIToolReferencesQueryParams = NonNullable<operations['listAIToolReferences']['parameters']['query']>;

export interface Input extends ListAIToolReferencesPathParams {
  apiVersion?: string;
  query?: ListAIToolReferencesQueryParams;
}

export async function listAIToolReferences(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-tools/{toolKey}/references', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
